const faqItems = [
  {
    q: '丫丫影院是免费的吗？需要注册吗？',
    a: '完全免费！丫丫影院承诺永久免费提供高清影视在线观看服务，无需注册、无需登录即可直接观看所有内容。我们通过广告投放维持运营，不会向用户收取任何费用。',
  },
  {
    q: '播放会卡顿吗？画质怎么样？',
    a: '丫丫影院采用全球CDN加速节点与智能码率自适应技术，根据您的网络状况自动匹配最佳清晰度。支持流畅、标清、高清1080P和超清4K多种画质选择，绝大部分地区均可实现即点即播、不缓冲的流畅体验。',
  },
  {
    q: '更新速度快吗？能第一时间看到最新电影吗？',
    a: '我们的内容团队每日同步更新，院线新片下映后最快7天内即可在丫丫影院上线高清版本。热播电视剧和综艺节目实现与电视台播出后2小时内同步更新，确保您不错过任何精彩内容。',
  },
  {
    q: '支持哪些设备观看？可以在电视上看吗？',
    a: '丫丫影院支持电脑（Windows/Mac）、平板（iPad/Android）、手机（iOS/Android）和智能电视（支持投屏功能）全平台观看。通过Chrome浏览器或手机App的投屏功能，即可将内容无缝投射到大屏电视上享受家庭影院体验。',
  },
  {
    q: '如何找到我想看的影片？',
    a: '您可以通过首页的搜索功能、分类导航栏或热门话题标签快速找到目标内容。我们还提供了按类型、地区、年份、评分等多维度筛选功能。首页的焦点专题和必看佳片模块也会定期推荐高分内容，帮助您发现好片。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            常见问答
          </h2>
          <p className="mt-2 text-foreground-500 text-sm md:text-base">
            关于丫丫影院的常见问题，这里都有答案
          </p>
        </div>

        <div className="space-y-4">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl p-6 md:p-7"
            >
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="shrink-0 w-7 h-7 rounded-lg bg-primary-100 flex items-center justify-center text-primary-600 text-sm font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <div className="flex items-start gap-3">
                <span className="shrink-0 w-7 h-7 rounded-lg bg-accent-100 flex items-center justify-center text-accent-600 text-sm font-bold mt-0.5">
                  A
                </span>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}